module.exports = __webpack_public_path__ + "static/media/1.5.84847de2.mp3";